export function _joinRouterCommands(routerCommands: any[]): string {
    if (routerCommands === undefined) return undefined;
    if (routerCommands === null) return null;
    if (routerCommands.length === 0) return '';

    const hasLeadingSlash = typeof routerCommands[0] === 'string' && routerCommands[0].startsWith('/');

    const cleanedParts = routerCommands.map((part) => (typeof part === 'string' ? part.replace(/^\/+|\/+$/g, '') : part)).filter((part) => part !== '');

    const result = cleanedParts.join('/');

    return hasLeadingSlash ? '/' + result : result;
}
